/**
 * Register popup — POST /apps/address-proxy/register (Worker → customerCreate).
 */

(() => {
  if (window.__ssbRegisterPopupBound) return;
  window.__ssbRegisterPopupBound = true;

  const PROXY = '/apps/address-proxy';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    document.querySelectorAll('[data-register-form]').forEach((form) => {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';
      const root = form.closest('[data-register-app]');
      const errorBox = root?.querySelector('[data-register-error]');
      const successBox = root?.querySelector('[data-register-success]');
      const panel = form.closest('[role="dialog"]');
      const footer = panel?.querySelector('[data-register-footer]');

      form.addEventListener('submit', async (ev) => {
        ev.preventDefault();
        hideError(errorBox);
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        try {
          const firstName = form.firstName?.value?.trim() || '';
          const lastName = form.lastName?.value?.trim() || '';
          const email = form.email?.value?.trim() || '';
          const phoneRaw = form.phone?.value?.trim() || '';
          const address = form.elements['meta_address']?.value?.trim() || '';
          const zip = form.elements['meta_zip']?.value?.trim() || '';

          if (!firstName || !lastName) {
            throw new Error(form.dataset.msgMissingName || 'Missing name');
          }
          if (!address) {
            throw new Error(form.dataset.msgMissingAddress || 'Missing address');
          }
          if (!zip) {
            throw new Error(form.dataset.msgMissingZip || 'Missing ZIP');
          }
          if (!phoneRaw) {
            throw new Error(form.dataset.msgMissingPhone || 'Missing phone');
          }

          const phoneE164 = combinePhone(
            form.phoneCountryCode?.value || '',
            phoneRaw
          );
          const payload = {
            firstName,
            lastName,
            email,
            phone: phoneE164,
            metafields: buildMetafields(form),
          };
          const res = await fetch(`${PROXY}/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(payload),
          });
          const data = await res.json();
          if (!data.ok) {
            throw new Error(formatRegisterError(data, form));
          }
          form.hidden = true;
          if (successBox) successBox.hidden = false;
          if (footer) footer.hidden = true;
        } catch (err) {
          showError(errorBox, err.message || form.dataset.msgGeneric || 'Error');
        } finally {
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    });
  }

  /**
   * Combine country dial code + local number into E.164 (`+<digits>`).
   * Drops any non-digits and a single leading 0 (common in many locales).
   * Returns '' if the local part is empty so optional phone stays optional.
   */
  function combinePhone(dialCode, local) {
    const localDigits = String(local || '')
      .replace(/\D/g, '')
      .replace(/^0+/, '');
    if (!localDigits) return '';
    const cc = String(dialCode || '').trim().replace(/^\+?/, '+');
    if (!/^\+\d+$/.test(cc)) return localDigits;
    return cc + localDigits;
  }

  function buildMetafields(form) {
    const out = [];
    form.querySelectorAll('[data-mf-key]').forEach((el) => {
      const namespace = el.dataset.mfNamespace || 'custom';
      const key = el.dataset.mfKey;
      const type = el.dataset.mfType || 'single_line_text_field';
      let val = el.value;
      if (el.type === 'checkbox') {
        val = el.checked ? 'true' : '';
      }
      if (!key || String(val).trim() === '') return;
      out.push({
        namespace,
        key,
        type,
        value: String(val).trim(),
      });
    });
    return out;
  }

  function formatRegisterError(res, form) {
    const code = res.error;
    if (code === 'invalid_email' && form.dataset.msgInvalidEmail) {
      return form.dataset.msgInvalidEmail;
    }
    if (code === 'invalid_phone' && form.dataset.msgInvalidPhone) {
      return form.dataset.msgInvalidPhone;
    }
    if (code === 'missing_name' && form.dataset.msgMissingName) {
      return form.dataset.msgMissingName;
    }
    if (code === 'missing_phone' && form.dataset.msgMissingPhone) {
      return form.dataset.msgMissingPhone;
    }
    if (code === 'email_taken' && form.dataset.msgEmailTaken) {
      return form.dataset.msgEmailTaken;
    }
    if (res.userErrors?.length) {
      const phoneErr = res.userErrors.find(
        (e) => Array.isArray(e.field) && e.field.includes('phone')
      );
      if (phoneErr && form.dataset.msgInvalidPhone) {
        return form.dataset.msgInvalidPhone;
      }
      return res.userErrors.map((e) => e.message).join(', ');
    }
    if (Array.isArray(res.errors) && res.errors.length) {
      return res.errors
        .map((e) => (typeof e === 'string' ? e : e.message || JSON.stringify(e)))
        .join(', ');
    }
    return form.dataset.msgGeneric || 'Unknown error';
  }

  function showError(box, msg) {
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }

  function hideError(box) {
    if (!box) return;
    box.textContent = '';
    box.hidden = true;
  }
})();
